import _get from 'lodash/get';
import fetcher from '../../../modules/ajio-fetch';
import { fetchGetJSONReqOpts, fetchGetJSONResHandler } from '../../../modules/ajio-fetch/utils';
import properties from '../../../modules/ajio-util/properties';
import { getIsAppFlagAtNode } from '../../../games/utils/gamePageUtilities';

const url = properties.getProperty('gamificationApiUrl');
const hybrisUrl = properties.getProperty('apiUrl');
const cartUrl = properties.getProperty('cartUrl') ? properties.getProperty('cartUrl') : hybrisUrl;

export async function getMicroCart(request) {
  const token = request.cookies.A;
  const cartId = request.cookies.C;
  const userName = request.cookies.U;
  const aguid = request.cookies.AGUID || '';
  const guid = request.cookies.GUID || '';
  let uuid = request.cookies.CI || '';
  if (!userName || !token) {
    return Promise.resolve(0);
  }
  if (userName === 'anonymous' && !aguid) {
    return Promise.resolve(0);
  }
  if (userName !== 'anonymous' && (!cartId || cartId === 'undefined')) {
    return Promise.resolve(0);
  }
  let param = `cartcode=${cartId}`;
  if (userName === 'anonymous' && aguid) {
    uuid = 'anonymous';
    param = `guid=${aguid}`;
  }

  const apiEndPoint = `${cartUrl}/service/cart/${uuid}/microcart?client_type=WEB?${param}`;
  return fetcher(
    apiEndPoint,
    fetchGetJSONReqOpts({
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        tenant: 'AJIO',
        'X-Client-Type': 'STOS',
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
      },
      credentials: 'include'
    })
  )
    .then(fetchGetJSONResHandler)
    .then(res => {
      return res.totalAmount;
    });
}

export async function getAssuredGift(request) {
  let orderValue = 0;
  const isAppFlag = getIsAppFlagAtNode(request);
  orderValue = _get(request, 'query.orderValue', 0);
  if (!isAppFlag && !_get(request, 'query.orderValue', false)) {
    orderValue = await getMicroCart(request);
  }
  console.log('TRACK GAME NOT FOUND EXCEPTION - getAssuredGift function');
  const apiEndPoint = `${url}/v1/assured-gifts/game/AssuredGifts?orderValue=${orderValue}`;
  return fetcher(
    apiEndPoint,
    fetchGetJSONReqOpts({
      method: 'GET',
      headers: {
        tenant: 'AJIO',
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
      },
      credentials: 'include'
    })
  )
    .then(fetchGetJSONResHandler)
    .then(res => {
      return {
        ...res,
        orderValue
      };
    })
    .catch(err => {
      console.log('Error in get AssuredGift API request ', err);
      return {};
    });
}
